import { ZodObject, z } from 'zod';
import { SelectionNodeSchema } from './SelectionNode';
import { OptionType } from './OptionType';

const LoafingShedSelectionNodeSchema = SelectionNodeSchema.extend({
  type: z.literal(OptionType.LoafingShedSection),
  x: z.number().optional(),
  y: z.number().optional(),
});

export const SelectionNodeSchemas: Partial<Record<OptionType, ZodObject<any>>> = {
  [OptionType.LoafingShedSection]: LoafingShedSelectionNodeSchema,
};
